/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_CurrentInputs */

const zh_subscription_current = /** @type {(inputs: Subscription_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前订阅`)
};

const en_subscription_current = /** @type {(inputs: Subscription_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Subscription`)
};

const es_subscription_current = /** @type {(inputs: Subscription_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción actual`)
};

/**
* | output |
* | --- |
* | "Current Subscription" |
*
* @param {Subscription_CurrentInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const subscription_current = /** @type {((inputs?: Subscription_CurrentInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_CurrentInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_current(inputs)
	if (locale === "en") return en_subscription_current(inputs)
	return es_subscription_current(inputs)
});